import React, { Fragment, ChangeEvent } from "react";

import withTitle from "../withTitle";

import { DateTime } from "luxon";

import { V1, V2 } from "../../Api";
import { formatName } from "../../Utilities";

interface IMetricsAnalysisEmployeeViewState {
    isLoading: boolean | string;

    dateStart: string;
    dateEnd: string;

    selectedEmployee: string;

    employees: any[];
}

class MetricsAnalysisEmployeeView extends React.Component<{}, IMetricsAnalysisEmployeeViewState> {
    constructor(props: Readonly<{}>) {
        super(props);

        const now = DateTime.local();
        const state: IMetricsAnalysisEmployeeViewState = {
            isLoading: false,

            dateStart: now.minus({ days: 365 }).toISODate(),
            dateEnd: now.toISODate(),

            employees: [],
            selectedEmployee: "",
        };

        this.state = state;

        this.handleElementChange = this.handleElementChange.bind(this);
    }

    public async componentDidMount() {
        try {
            const [employees] = await Promise.all([
                V1.get<any[]>(`employees/summary`)
            ]);

            employees.sort((a, b) => formatName(a.name).localeCompare(formatName(b.name)));

            this.setState({
                employees
            });
        }
        catch (e) {
            this.setState({
                isLoading: e.message || e || "Could not load data"
            });
        }
    }

    public render() {
        return (
            <div className="viewer-root viewer-full full-height-max">
                <div className="filter-control-box">
                    <select name="selectedEmployee" value={this.state.selectedEmployee} onChange={this.handleElementChange}>
                        <option value="">Select Employee...</option>
                        {this.state.employees.map(a => <option key={a.id} value={a.id}>{formatName(a.name)}</option>)}
                    </select>
                </div>
                <p>
                    TBD
                </p>
            </div>
        );
    }

    private handleElementChange(e: ChangeEvent<HTMLSelectElement> | ChangeEvent<HTMLInputElement>, afterCb?: () => void) {
        let value: string | number = e.currentTarget.value;
        const name = e.currentTarget.name;

        if ((name === "dateStart" || name === "dateEnd") && !value) {
            return;
        }

        if (name !== "selectedPreset") {
            this.setState({
                selectedPreset: "",
                [name]: value
            } as any, afterCb);
        }
        else {
            this.setState({
                [name]: value
            } as any, afterCb);
        }
    }
}

export default withTitle("Employee Analysis", MetricsAnalysisEmployeeView);